export type FieldMapType = {
  street: string,
  unit: string,
  city: string,
  state: string,
  zipcode: string,
  county?: string,
  countyFips?: string,
} | Record<string, never>;

export const BASE_FIELD_MAP = {
  street: 'street',
  unit: 'unit',
  city: 'city',
  state: 'state',
  zipcode: 'zipcode',
};

export const HOME_FIELD_MAP: FieldMapType  = {
  ...BASE_FIELD_MAP,
  county: 'county',
  countyFips: 'countyFips',
};

export const PROFILED_ADDRESS_FIELD_MAP = {
  ...HOME_FIELD_MAP,
  region: 'region',
};


export const ADDRESS_CHANGE_KEYS = ['state'];
export const GEO_RESPONSE_FORM_FIELDS = ['city', 'zipcode', 'county', 'state', 'countyFips'];
